import { jsx as _jsx } from "react/jsx-runtime";
import { system } from '@config/system';
import createCache from '@emotion/cache';
import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import { ROOT_CLASSNAME, ROOT_SELECTOR } from '@view/constants/root';
const PREFIX = 'd';
const emotionCache = createCache({
    key: PREFIX,
    prepend: true,
});
const originalInsert = emotionCache.insert;
// @TECHDEBT: We need to include these extra parents for portals that are apended to the body:
// - reach-portal: used by react-spring-bottom-sheet library, rendered by the legacy ShoppingCartMobileWrapper
const getSelector = (selector) => system.isImmersiveExperience && selector.startsWith(`.${PREFIX}-`)
    ? `:is(${ROOT_SELECTOR}, .${ROOT_CLASSNAME}, reach-portal) ${selector}`
    : selector;
emotionCache.insert = (...params) => {
    const [selector, serialized, sheet, shouldCache] = params;
    originalInsert(getSelector(selector), serialized, sheet, shouldCache);
};
export const StyleCacheProvider = ({ children, }) => (_jsx(EmotionCacheProvider, { value: emotionCache, children: children }));
